import { useContext } from 'react';
import { NavbarContext } from '../context/NavbarContext';

export default function useNavbar() {
  const navbar = useContext(NavbarContext);

  return navbar;
}
